const OPTIONS_CHAIN_VIEW_TYPES = {
  T_SHAPE: 'tShape',
  ALL: 'all',
  CALL: 'call',
  PUT: 'put',
} as const;

const T_SHAPE_VIEW_TYPES = {
  PRICE: 'price',
  OI_AND_VOLUMNE: 'oiAndVol',
  GREEKS: 'greeks',
} as const;

export { OPTIONS_CHAIN_VIEW_TYPES, T_SHAPE_VIEW_TYPES };
